__turbopack_context__.v({
  "label": "ButtonSizes-module__TGF6SG__label",
  "large": "ButtonSizes-module__TGF6SG__large",
  "small": "ButtonSizes-module__TGF6SG__small",
  "xlarge": "ButtonSizes-module__TGF6SG__xlarge",
  "xsmall": "ButtonSizes-module__TGF6SG__xsmall",
});
